import React from 'react';
import Icon from '../AppIcon';

const getRoleInfo = (role) => {
  switch (String(role)) {
    case '1':
      return {
        label: 'Administrator',
        description: 'Full system access with management capabilities',
        icon: 'Shield',
        bgColor: 'bg-primary/10',
        textColor: 'text-primary',
        borderColor: 'border-primary/20',
        roleName: 'Admin'
      };
    case '3':
      return {
        label: 'Client',
        description: 'API documentation and key management access',
        icon: 'Code',
        bgColor: 'bg-accent/10',
        textColor: 'text-accent',
        borderColor: 'border-accent/20',
        roleName: 'Client'
      };
    case '4':
      return {
        label: 'Courier',
        description: 'Courier access for deliveries',
        icon: 'Truck', // Use an appropriate icon name
        bgColor: 'bg-green-100',
        textColor: 'text-green-700',
        borderColor: 'border-green-200',
        roleName: 'Courier'
      };
    default:
      return {
        label: 'Unknown',
        description: 'Unknown role',
        icon: 'User',
        bgColor: 'bg-muted',
        textColor: 'text-muted-foreground',
        borderColor: 'border-border',
        roleName: 'Unknown'
      };
  }
};

const RoleBadge = ({ onClick }) => {
  // Get user info from localStorage
  const firstName = localStorage.getItem('first_name') || '';
  const role = localStorage.getItem('role') || '1'; // default to '1' (Admin) if not set

  const config = getRoleInfo(role);

  return (
    <div 
      className={`
        flex items-center space-x-3 p-3 rounded-lg border transition-smooth
        ${config.bgColor} ${config.borderColor}
        ${onClick ? 'cursor-pointer hover:shadow-soft' : ''}
      `}
      onClick={onClick}
      title={config.description}
    >
      <div className={`
        w-8 h-8 rounded-full flex items-center justify-center
        ${config.bgColor} ${config.textColor}
      `}>
        <Icon name={config.icon} size={16} />
      </div>
      <div className="flex-1 min-w-0">
        <p className={`text-sm font-medium ${config.textColor}`}>
          {/* {firstName ? `${firstName} (${config.label})` : config.label} */}
          {firstName ? `${firstName}` : config.label}
        </p>
        <p className="text-xs text-muted-foreground truncate">
          {config.roleName}
        </p>
      </div>
      {onClick && (
        <Icon 
          name="ChevronRight" 
          size={14} 
          className="text-muted-foreground" 
        />
      )}
    </div>
  );
};

export default RoleBadge;